<template>
  <v-card class="pa-2" :color="color" elevation="2" outlined>
    <router-link
      :to="{ name: 'verSala', params: { id: id } }"
      class="link text-h6 font-weight-bold ml-2"
      :class="{ 'primary--text': disponivel, 'grey--text': !disponivel }">
      {{ nome }}
    </router-link>
    <v-row>
      <v-col cols="12" sm="6" class="text-caption">
        <div class="mt-3 ml-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <span>
                <v-icon color="primary" v-on="{ ...tooltip }"> groups </v-icon>
                {{ capacidade }}
              </span>
            </template>
            <span>Capacidade de até {{ capacidade }} pessoas</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <span>
                <v-icon
                  v-on="{ ...tooltip }"
                  :color="computadores ? 'primary' : undefined">
                  mdi-desktop-classic
                </v-icon>
                <template v-if="computadores">{{ computadores }}</template>
              </span>
            </template>
            <span v-if="computadores"
              >{{ computadores }} computadores disponíveis</span
            >
            <span v-else>Sala sem computadores</span>
          </v-tooltip>

          {{ localizacaosala + ", " }} {{ localizacaoandar + "º Piso" }}
        </div>
      </v-col>

      <v-col cols="12" sm="6" class="text-sm-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon
              v-on="{ ...tooltip }"
              small
              dense
              :color="arcondicionado ? 'primary' : undefined"
              >ac_unit</v-icon
            >
          </template>
          <span>Ar-Condicionado</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon
              v-on="{ ...tooltip }"
              small
              class="ml-1"
              :color="mesa ? 'primary' : undefined"
              >chair_alt</v-icon
            >
          </template>
          <span>Mesa</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon
              v-on="{ ...tooltip }"
              small
              dense
              class="ml-1"
              :color="lousa ? 'primary' : undefined"
              >call_to_action</v-icon
            >
          </template>
          <span>Lousa</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon
              v-on="{ ...tooltip }"
              small
              class="ml-1 mr-2"
              :color="projetor ? 'primary' : undefined"
              >videocam</v-icon
            >
          </template>
          <span>Projetor</span>
        </v-tooltip>
        <slot>
          <v-btn
            v-if="isResponsavel || isPrefeitura"
            class="button-card text-capitalize mr-1 ml-2"
            color="primary"
            small
            dark
            :to="{ name: 'editarSala', params: { id: id } }"
            >Editar Sala</v-btn
          >

          <v-btn
            v-if="isResponsavel"
            icon
            large
            color="red"
            class="text--darken-4"
            dark
            @click.prevent="dialogDelete = true">
            <v-icon> mdi-delete-circle </v-icon></v-btn
          >
        </slot>
      </v-col>
    </v-row>
    <v-delete-sala-dialog
      :visivel="dialogDelete"
      @close="dialogDelete = false"
      @confirma="$emit('delete', id), (dialogDelete = false)" />
  </v-card>
</template>

<script>
import VDeleteSalaDialog from "@/components/dialogs/sala/VDeleteSalaDialog.vue"
import { mdiDelete } from "@mdi/js"
import { mapGetters } from "vuex"

export default {
  name: "v-card-sala",
  components: { VDeleteSalaDialog },
  props: {
    id: {
      type: Number,
    },
    nome: {
      type: String,
    },
    responsavel: {
      type: Object,
    },
    capacidade: {
      type: Number,
    },
    computadores: {
      type: Number,
    },
    arcondicionado: {
      type: Boolean,
      default: false,
    },
    projetor: {
      type: Boolean,
      default: false,
    },
    lousa: {
      type: Boolean,
      default: false,
    },
    mesa: {
      type: Boolean,
      default: false,
    },
    localizacaosala: {
      type: String,
    },
    localizacaoandar: {
      type: Number,
    },
    disponivel: {
      type: Boolean,
      default: true,
    },
    data: () => ({
      icons: {
        mdiDelete,
      },
    }),
    color: {
      type: String,
      default: "accent",
    },
  },
  data() {
    return {
      dialogDelete: false,
    }
  },
  computed: {
    isResponsavel() {
      return this.responsavel.data.id === this.userId
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
      userId: ["auth/userId"],
    }),
  },
}
</script>

<style scoped>
.link:hover {
  text-decoration: underline;
}
.link {
  text-decoration: none;
}
</style>
